<template>
  <div class="app">
    <!-- 仅保留路由渲染出口，所有页面在这里切换 -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style scoped>
.app {
  min-height: 100vh;
  background: #f8fafc;
}
</style>